/**
 * DemoBanner — persistent prototype indicator.
 * CLAUDE.md Security #4: never hidden, never dismissable.
 * Atlas: global shell.
 */
"use client";

import Link from "next/link";
import { useT } from "@/lib/locale";

interface DemoBannerProps {
  exitHref?: string;
}

export function DemoBanner({ exitHref }: DemoBannerProps) {
  const t = useT();
  return (
    <div
      role="status"
      aria-label="Demo notice"
      className="w-full bg-brand-accent text-neutral-900 py-1.5 px-4 text-center text-xs font-semibold tracking-wide flex items-center justify-center gap-3"
    >
      <span>{t("demo.banner")}</span>
      {exitHref && (
        <Link
          href={exitHref}
          className="text-neutral-700 hover:text-neutral-900 underline underline-offset-2 transition-colors"
        >
          {t("demo.backToOverview")}
        </Link>
      )}
    </div>
  );
}
